import { IconHelp } from "../IconHelp"
import { STYLING_CATEGORY } from '../../../helpers/widget'

export const sideMenuConfigs = [
  {
    name: 'query',
    advanced: true,
    type: 'yasgui',
    label:
      'Query to fill tree. First item should be the object label, the second the object URI, the third the parent URI. optional you can use icon, icon2 and icon3 variables for fa-fa icons ()',
  },
  {
    name: 'tabs',
    type: 'array',
    label: 'Tabs',
  },
  {
    name: 'tabSelectionSubscription',
    type: 'text',
    label: 'Variabele to listen to for tab selection',
  },
  {
    name: 'hideTabs',
    advanced: true,
    type: 'text',
    label:
      'Variabele to listen to for tab visualisation. Use tab names to hide the tabs',
  },
  {
    name: 'disableHiddenTabs',
    advanced: true,
    type: 'boolean',
    label:
      'show the hidden tabs but disable them and use a lock icon'
  },
  {
    name: 'icons',
    category: STYLING_CATEGORY,
    type: 'array',
    label: 'comma separated icon names for each tab',
    helpComponent: IconHelp,
  },
  {
    name: 'headertext',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'text for the header when expanded',
  },
  {
    name: 'lazyLoadingPages',
    advanced: true,
    type: 'boolean',
    label: 'does not load the tabs/pages in advance. Also returning to a page results in a reload',
  },
  {
    name: 'footertext',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'text for the footer',
  },
  {
    name: 'backgroundimage',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'background image',
  },
  {
    name: 'customStyling',
    category: STYLING_CATEGORY,
    type: 'boolean',
    label: 'Enable Custom Styling',
  },
  {
    name: 'sidemenuBackgroundColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The background Color in Hex format. e.g. #000000',
  },
  {
    name: 'sidemenuTabColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The background color of the tab in Hex format. e.g. #000000',
  },
  {
    name: 'sidemenuTabIconColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The background color of the tab icon of the tab in Hex format. e.g. #000000',
  },
  {
    name: 'sidemenuTabTextColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The text color of the tab in Hex format. e.g. #000000',
  },
  {
    name: 'sidemenuTabHoverColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The background color of the tab on mouse hovering in Hex format. e.g. #000000',
  },
  {
    name: 'sidemenuTabIconHoverColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The background color of the tab icon on mouse hovering in Hex format. e.g. #000000',
  },
  {
    name: 'sidemenuTabTextHoverColor',
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'The text color of the tab on mouse hovering in Hex format. e.g. #000000',
  },
  {
    name: 'startCollapsed',
    category: STYLING_CATEGORY,
    type: 'boolean',
    label: 'start collapsed',
  },
  {
    name: 'onlyCollapsed',
    category: STYLING_CATEGORY,
    type: 'boolean',
    label: 'only collapsed',
  },
  {
    name: 'rightside',
    category: STYLING_CATEGORY,
    type: 'boolean',
    label: 'show menu on the rightside',
  },
  {
    name: 'className',
    advanced: true,
    category: STYLING_CATEGORY,
    type: 'text',
    label: 'css classNames',
  },
  {
    name: 'areas',
    advanced: true,
    type: 'json',
    // label: 'Column widths or row heights (separated by commas). Value can be a number (which will be set as flex values/verhoudingswaarden) or a px/% value',
    label: 'area definitions',
  },
] as const
